import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between mb-1" }
const _hoisted_2 = { class: "text-body-2 text-medium-emphasis" }
const _hoisted_3 = { class: "material-symbols-outlined text-medium-emphasis" }
const _hoisted_4 = { class: "text-h5 font-weight-bold mb-1" }
const _hoisted_5 = {
  key: 1,
  class: "text-body-2 text-medium-emphasis mb-2"
}

import { computed } from 'vue'
import type { ApexOptions } from 'apexcharts'
import type { KpiStat } from '@/services/adminStatsApi'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsKpiCards',
  props: {
    questions: {},
    tokens: {},
    rating: {}
  },
  setup(__props: any) {

const props = __props

function formatToken(v: number | null): string {
  if (v === null) return '—'
  if (v >= 1_000_000) return (v / 1_000_000).toFixed(1) + 'M'
  if (v >= 1_000) return Math.round(v / 1_000) + 'K'
  return v.toLocaleString('tr-TR')
}

const cards = computed(() => [
  {
    key: 'questions',
    label: 'Toplam Soru',
    icon: 'chat_bubble_outline',
    color: '#3b82f6',
    formatted: (props.questions.current ?? 0).toLocaleString('tr-TR'),
    changePct: props.questions.change_pct,
    sparkline: props.questions.sparkline ?? [],
  },
  {
    key: 'tokens',
    label: 'Toplam Token',
    icon: 'token',
    color: '#8b5cf6',
    formatted: formatToken(props.tokens.current),
    changePct: props.tokens.change_pct,
    sparkline: props.tokens.sparkline ?? [],
  },
  {
    key: 'rating',
    label: 'Ortalama Puan',
    icon: 'star',
    color: '#f59e0b',
    formatted: props.rating.current !== null ? `${props.rating.current} ★` : '—',
    changePct: props.rating.change_pct,
    sparkline: props.rating.sparkline ?? [],
  },
])

function sparklineOptions(color: string): ApexOptions {
  return {
    chart: {
      sparkline: { enabled: true },
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: { curve: 'smooth', width: 2 },
    colors: [color],
    fill: {
      type: 'gradient',
      gradient: { opacityFrom: 0.4, opacityTo: 0.0 },
    },
    tooltip: { enabled: false },
    dataLabels: { enabled: false },
    xaxis: { labels: { show: false }, axisBorder: { show: false }, axisTicks: { show: false } },
    yaxis: { show: false },
    grid: { show: false, padding: { top: 0, bottom: 0, left: 0, right: 0 } },
  }
}

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card) => {
        return (_openBlock(), _createBlock(_component_v_col, {
          key: card.key,
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "trezo-card bg-white border-0 shadow-none border-radius mb-0 pa-4" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(card.label), 1),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(card.icon), 1)
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(card.formatted), 1),
                (card.changePct !== null)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["text-body-2 mb-2", card.changePct >= 0 ? 'text-success' : 'text-error'])
                    }, [
                      _createTextVNode(_toDisplayString(card.changePct >= 0 ? '▲' : '▼') + " " + _toDisplayString(Math.abs(card.changePct)) + "% ", 1),
                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-medium-emphasis" }, "önceki döneme göre", -1))
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, "Karşılaştırma verisi yok")),
                (card.sparkline.length)
                  ? (_openBlock(), _createBlock(_component_apexchart, {
                      key: 2,
                      type: "area",
                      height: "40",
                      options: sparklineOptions(card.color),
                      series: [{ name: card.label, data: card.sparkline }]
                    }, null, 8, ["options", "series"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})